import React from 'react';
import './MedicationRow.css';

export interface Medication {
  id: string;
  name: string;
  // times: { [hour: string]: number | '' };
  times: Record<string, number | ''>;
  indication: string;
  instruction: string;
  isNew?: boolean;
  isRemoval?: boolean;
  isEdit?: boolean;

  // NEW optional structured fields
  scheduleType?: 'daily' | 'weekly';
  doses?: Record<string, number>;
  weekdays?: number[];
  advanced?: Record<number, Record<string, number>>;
  endDate?: { year: number; month: number; day: number };
}

interface MedicationRowProps {
  med: Medication;
  onClick?: (med: Medication) => void;
}

const MedicationRow: React.FC<MedicationRowProps> = ({ med, onClick }) => {
  const handleClick = () => {
    if (onClick) onClick(med);
  };

  // Apply clickable styling class
  const clickableProps = {
    onClick: handleClick,
    className: 'clickable-med-row',
  };

  // Simple “staged” rows (green or red)
  if (med.isNew || med.isRemoval || med.isEdit) {
    const isRemove = !!med.isRemoval;
    const isEdit = !!med.isEdit;

    // Show instruction for add and edit; not for remove
    const showInstruction = !isRemove && med.instruction && med.instruction.trim().length > 0;
    const lineText = showInstruction ? `${med.name} - ${med.instruction}` : med.name;

    const rowClass = isRemove ? 'simple-red' : isEdit ? 'simple-orange' : 'simple-green';
    const chipClass = isRemove ? 'chip-red' : isEdit ? 'chip-orange' : 'chip-green';
    const chipText = isRemove
      ? 'Lyf tekið úr skömmtun'
      : isEdit
        ? 'Breyting á lyfi'
        : 'Lyfi bætt við skömmtun';

    return (
      <div {...clickableProps} className={`med-row simple ${rowClass} clickable-med-row`}>
        <div className="med-line">{lineText}</div>
        <div className={`status-chip ${chipClass}`}>{chipText}</div>
      </div>
    );
  }

  // Fallback (existing/old rows if needed)
  return (
    <div {...clickableProps} className="medication-row default clickable-med-row">
      <div className="medication-line">
        {med.name}
        {med.instruction ? ` - ${med.instruction}` : ''}
      </div>
    </div>
  );
};
// <div className={`medication-row ${med.isNew ? 'new-medication' : ''}`}>
//   <div className="medication-name">{med.name}</div>
//   <div className="medication-dose">{med.times['9'] || ''}</div>
//   <div className="medication-dose">{med.times['22'] || ''}</div>
// </div>
// );

export default MedicationRow;
